import React from 'react';
import KoobButton from '@koob/ui/src/components/KoobButton';

interface TripTemplateImageUploadProps {
  // The picture the user loaded, as a data URL.
  uploadedImage: string | null;
  selectedImage: string | null;
  importLabel: string;
  onUpload: (image: string | null) => void;
}

export default function TripTemplateImageUpload({
  uploadedImage,
  selectedImage,
  importLabel,
  onUpload,
}: TripTemplateImageUploadProps) {
  const handleLoadFile = (event: React.ChangeEvent<HTMLInputElement>) => {
    const [file] = Array.from(event.target.files ?? []);
    if (!file) {
      return;
    }

    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onloadend = () => onUpload(reader.result as string);
  };

  return (
    <div className="flex flex-col gap-2 mt-3">
      <div
        className={[
          'h-32 w-32 rounded-md overflow-hidden ring-4',
          uploadedImage === selectedImage ? 'ring-orange-500' : 'ring-gray-300',
        ].join(' ')}
      >
        <img
          className="h-32 w-32 object-cover bg-orange-100"
          src={uploadedImage ?? '/img/headerData-image-placeholder.png'}
          alt="upload"
        />
      </div>

      <div className="flex gap-2">
        <KoobButton variant="secondary" asChild>
          <label>
            {importLabel}
            <input
              type="file"
              accept="image/*"
              onChange={handleLoadFile}
              onClick={(event) => {
                (event.target as HTMLInputElement).value = '';
              }}
              style={{ display: 'none' }}
              data-testid="img-template"
            />
          </label>
        </KoobButton>

        {Boolean(uploadedImage) && (
          <KoobButton
            type="button"
            variant="ghost"
            onClick={() => onUpload(null)}
          >
            <i className="fa-regular fa-trash-can text-2xl text-gray-400" />
          </KoobButton>
        )}
      </div>
    </div>
  );
}
